<template>
  <layout :title-text="title">
    <div slot="content" class="awards-container">
      <div class="awards-content">
        <div class="part-one">
          <div class="first-prize" @click="wangDingClick"></div>
        </div>
        <div class="part-two">
          <div :class="item" v-for="(item, index) in classList.partTwo" :key='index'></div>
        </div>
        <div class="part-there">
          <div :class="item" v-for="(item, index) in classList.partThere" :key='index'></div>
        </div>
      </div>
      <div class="awards-explain">
        <h1>教师奖项评奖细则</h1>
        <div :class="index === 0 ? 'explain-list' : ''" v-for="(item, index) in explainList" :key="index">
          <img class="explain-icon" src="../../assets/images/icon_awards_explain.png" draggable="false"/>
          <img class="explain-title" :src=item.imgUrl draggable="false"/>
          <div class="awards-text">
            <span v-for="(subItem,index) in item.text" :key="index" v-html="subItem"></span>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
import bestPrize from '@/assets/images/icon_best_prize.png'
import mvpTeacher from '@/assets/images/icon_mvp_teacher.png'

export default {
  components: {
    Layout
  },
  data () {
    return {
      title: '奖项设置',
      classList:
      {
        partTwo: ['second-prize', 'third-prize', 'wining-prize', 'best-leader', 'prominent-leader', 'good-leader'],
        partThere: ['good-guidance', 'mvp-teacher']
      },
      explainList: [
        {
          imgUrl: bestPrize,
          title: '最佳领队奖、杰出领队奖、优秀领队奖、 优秀技术指导奖',
          text: ['<b>评选时间： </b>在总决赛现场进行评选，决赛后公布获奖教师名单。', '<b>评选规则：</b> 总决赛第一名的指导老师获得最佳领队奖，一二三等奖参赛队伍的指导教师分别获得杰出领队奖、优秀领队奖、优秀技术指导奖，证书由公安部网络安全保卫局盖章，奖金、 丛书由奇安信科技集团股份有限公司赞助。']
        },
        {
          imgUrl: mvpTeacher,
          title: '5周年MVP教师奖',
          text: ['<b>评选时间： </b>在<a style="color: rgba(55, 234, 255, 1); border-bottom: 1px solid rgba(55, 234, 255, 1);" href="https://bcs.qianxin.com/" target="_blank">【2021北京网络安全大会】</a>预热阶段进行评选，为期一周，决赛公布获奖名单。', '<b>评选规则： </b>参与评选教师需带队参加至少三届蓝帽杯比赛，所带队伍至少获得一次一等奖，参赛老师需自行报名参加并提供相关证明，经大赛组委会审核后即可参与评选。<p></p>评选期间，每人每天有1次投票机会，每次可以最多为5名教师进行投票。投票最终得分最高的前5位老师，获得蓝帽杯20215周年MVP教师奖，证书由公安部网络安全保卫局盖章，丛书由奇安信科技集团股份有限公司赞助。']
        }
      ]
    }
  },
  methods: {
    /**
     * @desc 跳转至第三届网鼎杯
     */
    wangDingClick () {
      window.open('https://www.wangdingcup.com/', '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.awards-container {
  margin: 0 auto;
  width: 1000px;
  height: 1940px;
  background: url(../../assets/images/bg_awards_setting.png) no-repeat;
  .awards-content {
    position: relative;
    width: 100%;
    padding-top: 58px;
    .part-two {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      > div {
        width: 30%;
      }
    }
    .part-there {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      > div {
        width: 30%;
      }
    }
    /* 一等奖 */
    .first-prize {
      margin: 0 auto;
      width: 290px;
      height: 320px;
      cursor: pointer;
      background: url(../../assets/images/img_first_prize.png) no-repeat 100% 100%;
    }
    .first-prize:hover {
      background:url(../../assets/images/img_first_prize_hover.png) no-repeat 100% 100%;
    }
    /* 二等奖 */
    .second-prize {
      background: url(../../assets/images/img_second_prize.png) 57px 0 no-repeat;
    }
    .second-prize::after{
      content: "";
      display: block;
      padding-bottom: 100%;
    }
    .second-prize:hover {
      background: url(../../assets/images/img_second_prize_hover.png) 57px 0 no-repeat;
    }
    /* 三等奖 */
    .third-prize {
      background: url(../../assets/images/img_third_prize.png) 30px 0 no-repeat;
    }
    .third-prize:hover {
      background:url(../../assets/images/img_third_prize_hover.png) 30px 0 no-repeat;
    }
    /* 优胜奖 */
    .wining-prize {
      background: url(../../assets/images/img_wining_prize.png) no-repeat;
    }
    .wining-prize:hover {
      background:url(../../assets/images/img_wining_prize_hover.png) no-repeat;
    }
    /* 最佳领队奖 */
    .best-leader {
      background: url(../../assets/images/img_best_leader.png) 57px 0 no-repeat;
    }
    .best-leader::after{
      content: "";
      display: block;
      padding-bottom: 100%;
    }
    .best-leader:hover {
      background:url(../../assets/images/img_best_leader_hover.png) 57px 0 no-repeat;
    }
    /* 杰出领队奖 */
    .prominent-leader {
      background: url(../../assets/images/img_prominent_leader.png) 30px 0 no-repeat;
    }
    .prominent-leader:hover {
      background:url(../../assets/images/img_prominent_leader_hover.png)30px 0 no-repeat;
    }
    /* 优秀领队奖 */
    .good-leader {
      background: url(../../assets/images/img_good_leader.png) no-repeat;
    }
    .good-leader:hover {
      background:url(../../assets/images/img_good_leader_hover.png)  no-repeat;
    }
    /* 优秀技术指导奖 */
    .good-guidance {
      background: url(../../assets/images/img_good_guidance.png) 15px 0 no-repeat;
    }
    .good-guidance:hover {
      background:url(../../assets/images/img_good_guidance_hover.png) 15px 0 no-repeat;
    }
    .good-guidance::after{
      content: "";
      display: block;
      padding-bottom: 100%;
    }
    /* MVP教师奖 */
    .mvp-teacher {
      background: url(../../assets/images/img_mvp_teacher.png) 25px 0 no-repeat;
    }
    .mvp-teacher:hover {
      background:url(../../assets/images/img_mvp_teacher_hover.png) 25px 0 no-repeat;
    }
  }
  .awards-explain {
    margin: 0 60px 0 60px;
    text-align: left;
    h1 {
      margin: 45px 0 46px 0;
      text-align: center;
      font-size: 24px;
      font-family: SourceHanSansCN;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 10px;
      background: url(../../assets/images/bg_explain_title.png) no-repeat;
      background-position-x: center;
    }
    .explain-list{
      margin-bottom: 30px;
      border-bottom: 1px dashed rgba(88, 145, 250, 1);
    }
    .explain-icon {
      vertical-align: middle;
    }
    .explain-title {
      vertical-align: middle;
      margin-left: 10px;
    }
    .awards-text {
      margin-top: 29px;
      padding-bottom: 15px;
    }
    span {
      display: block;
      margin-bottom: 20px;
      line-height: 24px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      text-indent: -5.4rem;
      margin-left: 5.4rem;
      text-align: justify;
      font-weight: 400;
      color: #5891FA;
    }
  }
}
</style>
